import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import client from "@/api";
import { useApp } from "@/context/AppContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser, setAccessStatus, checkAuth } = useApp();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { navigate("/"); return; }
    (async () => {
      try {
        const linkIntent = localStorage.getItem("linkIntent");
        if (linkIntent) {
          localStorage.removeItem("linkIntent");
          await client.post("/auth/link", { provider: linkIntent, session_id: sid });
          await checkAuth();
          window.history.replaceState(null, "", "/profile");
          navigate("/profile");
          return;
        }
        const { data } = await client.post("/auth/session", { session_id: sid });
        setUser(data.user);
        setAccessStatus(data.access_status);
        window.history.replaceState(null, "", "/dashboard");
        navigate(data.access_status === "approved" ? "/dashboard" : "/status", { state: { user: data.user } });
      } catch (e) {
        const linkErr = e.response?.data?.detail;
        navigate(linkErr ? "/profile" : "/", { state: { linkError: linkErr } });
      }
    })();
  }, [location, navigate, setUser, setAccessStatus, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0d0d0d]">
      <div className="text-[#D21F2A] animate-pulse font-serif text-xl">4Flair …</div>
    </div>
  );
}
